import type { Pinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate'

function getSafeLocalStorage(): Storage | undefined {
  try {
    return localStorage
  }
  catch {
    return undefined
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  (nuxtApp.$pinia as Pinia).use(createPersistedState({
    storage: getSafeLocalStorage(),
  }))
})
